import { Container, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { getb2bAgnetListApi } from "src/Api/Services/AgentFareRule";
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import useSettings from "src/hooks/useSettings";
import { PATH_DASHBOARD } from "src/routes/paths";
import AddIcon from "@mui/icons-material/Add";
import AddAgentFareRuleMgtComp from "./AddAgentFareRuleMgtComp";
import AgentsFareRuleTabel from "./AgentsFareRuleTabel";
import UpdateAgentFareRuleComp from "./UpdateAgentFareRuleComp";
import LoadingScreen from "src/components/LoadingScreen";
import CustomModalComp from "src/components/CustomComponents/CustomModalComp";
const AgentFareRule = () => {
  const { themeStretch } = useSettings();
  const [getAgentData, setAgnentData] = useState([]);
  const [show, setShow] = useState(false);
  const [editData, setEditData] = useState("");
  const [loading, setloading] = useState(true);
  const fetchData = async () => {
    try {
      const { data } = await getb2bAgnetListApi();
      let newRes = data.agents.length > 0 ? data.agents : [];
      setAgnentData(newRes || []);
    } catch (error) {
    } finally {
      setloading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  if (loading) {
    return <LoadingScreen />;
  }
  return (
    <Container maxWidth={themeStretch ? false : "xxxl"} spacing={1}>
      <HeaderBreadcrumbs
        heading="Agent Fare Rule Management"
        links={[
          { name: "Dashboard", href: PATH_DASHBOARD.root },
          {
            name: "Add Fare Rule",
            href: PATH_DASHBOARD.farerule.addAgentRule,
          },
        ]}
      />
      <div className="text-right">
        <Button
          onClick={() => {
            setShow(true);
            setEditData("");
          }}
          variant="outlined"
        >
          Add Agent <AddIcon />
        </Button>
      </div>
      {getAgentData.length > 0 && (
        <AgentsFareRuleTabel
          getAgentData={getAgentData}
          editBtnClick={(it) => {
            setEditData(it);
            setShow(true);
          }}
          fetchData={fetchData}
        />
      )}
      <CustomModalComp
        show={show}
        onHide={() => setShow(false)}
        title={(editData ? "Update" : "Add") + " Agent Fare Rule"}
        backdrop={true}
      >
        {editData ? (
          <UpdateAgentFareRuleComp
            setShow={setShow}
            agentList={["ALL", ...getAgentData.map((item) => item.username)]}
            fetchData={fetchData}
            editData={editData}
          />
        ) : (
          <AddAgentFareRuleMgtComp
            setShow={setShow}
            agentList={["ALL", ...getAgentData.map((item) => item.username)]}
            fetchData={fetchData}
          />
        )}
      </CustomModalComp>
    </Container>
  );
};

export default AgentFareRule;
